import React from 'react';
//import { Link, Outlet } from "react-router-dom";
import { getPokerServiceLocationBase } from '../../common/api/data';
//import { parse } from 'html-react-parser';
import { useState, useEffect, useMemo } from "react";

//import { LeadersTable } from './poker_components/leaderstable';
//import { SortableLeadersTable } from './poker_components/sortableleaderstable';
import { PlayerIdsTable } from './poker_components/playeridstable';
import { FileUploadSingle } from '../../common/ui/fileupload';

import MagicTable from "../../common/ui/magictable";

import { parseISO, format } from 'date-fns';

const UPLOAD_MESSAGE = 'Please wait about 15 seconds for processing.  Another popup will appear when finished.  (server: ' + getPokerServiceLocationBase() + ')';
const formatDate = (dateString): string => {
	if (dateString === null || dateString === undefined || dateString === '') {
		return 'Loading.........';
	}
	return dateString === undefined ? 'Loading...' : format(parseISO(dateString), "MM/dd/yyyy h:mm:ss a");
};

interface IdWithoutName {
	playerId: string,
	playerNickname: string,
}

interface DashboardPackage {
	fileUploadedDate: string,
	mostRecentGameDate: string,
	idsWithoutNames: IdWithoutName[],
}

const PokerNow = () => {
	const [dashboardPackage, setDashboardPackage] = useState<DashboardPackage>({fileUploadedDate: '', mostRecentGameDate: '', idsWithoutNames: [] });
	const [data, setData] = useState([]);

	//var parse = require('html-react-parser');

	const pageLoadFunction = async () => {
		//alert('pageLoad()');
		loadDashboardData('dashboard');
	};

	useEffect( () => {pageLoadFunction(); }, [] );

	const loadDashboardData = (type) => {
		//alert('loadDataShortWay')
		console.log('loadDataShortWay');
		fetch(getPokerServiceLocationBase() + '/' + type).then(r => {
			r.json().then(j => {
				console.log('json');
				console.log(j);
				// set j to your page variable or do whatever with it
				setDashboardPackage(j);
				setData(j.allLeaders);
			})
			.catch(f => {
				console.log('json error');
				console.log(f);
			});
		})
		.catch(e => {
			console.log('fetch error');
			console.log(e);
		});
	};

	const columns = useMemo(
		() => [
			{
                Header: () => (<div className={"names"}>Player</div>),
                Cell: row => (<div className={"names"}>{row.value}</div>),
				accessor: "personRealname",
			},
			{
                Header: () => (<div className={"numbers"}>Wins</div>),
                Cell: row => (<div className={"numbers"}>{row.value}</div>),
				accessor: "count",
			},
			{
                Header: () => (<div className={"numbers"}>Money</div>),
                Cell: row => (<div className={"numbers"}>{row.value}</div>),
				accessor: "sum",
			},
		],
		[]
	);

	return (
		<div>
			<h1>Poker Now Dashboard</h1>
			<div style={{fontSize: 11}}>
				<strong>File Last Uploaded:</strong> {formatDate(dashboardPackage.fileUploadedDate)}<br/>
				<strong>Most Recent Game:</strong> {formatDate(dashboardPackage.mostRecentGameDate)}
			</div>
			<table className={"mainTable"}>
				<tbody>
					<tr>
						<td style={{verticalAlign: 'top'}}><MagicTable title={'Summary'} columns={columns} data={data} /></td>
						<td style={{verticalAlign: 'top'}}><PlayerIdsTable title={'Ids Without Names'} list={dashboardPackage.idsWithoutNames} players={data} reloadApplication={pageLoadFunction} /></td>
					</tr>
					<tr>
						<td colSpan={1} align='left' style={{verticalAlign: 'top'}}><h3>Ledger Upload</h3><FileUploadSingle processCallback={pageLoadFunction} uploadMessage={UPLOAD_MESSAGE} /></td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>
	);

};

export default PokerNow;
